import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SessionTimeoutService } from './core/services/session-timeout.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'Optwaves POS';
  showLayout = true;

  constructor(
    private router: Router,
    private sessionTimeout: SessionTimeoutService,
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        // Hide layout for auth and public legal/support routes
        this.showLayout =
          !event.url.includes('/auth') && !event.url.includes('/legal');
      });
  }
}
